import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { SettingsComponent } from "./settings.component";
import { HistoryComponent } from "./history/history.component";
import { InvoicesComponent } from "./invoices/invoices.component";
import { TeamComponent } from "./team/team.component";
import { WhitelistComponent } from "./whitelist/whitelist.component";
import { LocationsComponent } from "./locations/locations.component";
import { EmailTesterComponent } from "./email-tester/email-tester.component";
import { PushNotificationsComponent } from "./push-notifications/push-notifications.component";
import { SuperAdminGuard } from "../../core/guards/super-admin.guard";

const routes: Routes = [
  {
    path: "",
    component: SettingsComponent,
    children: [
      {
        path: "",
        redirectTo: "team",
        pathMatch: "full",
      },
      {
        path: "history",
        component: HistoryComponent,
      },
      {
        path: "invoices",
        component: InvoicesComponent,
      },
      {
        path: "email-tester",
        component: EmailTesterComponent,
        canActivate: [SuperAdminGuard],
      },
      {
        path: "push-notifications",
        component: PushNotificationsComponent,
        canActivate: [SuperAdminGuard],
      },
      {
        path: "team",
        component: TeamComponent,
      },
      {
        path: "whitelist",
        component: WhitelistComponent,
      },
      {
        path: "locations",
        component: LocationsComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SettingsRoutingModule {}
